import { Provider } from "components/judicial-records/JudicialRecordsContext";
import SearchForm from "components/judicial-records/JudicialRecordsSearch";
import JudicialRecordsTable from "components/judicial-records/JudicialRecordsTable";
import { useTranslation } from "react-i18next";

export const JudicialRecords = () => {
    //! state
    const { t, i18n } = useTranslation(["judicial-records", "common"]);

    //! return
    return (
        <Provider>
            <div className="grid crud">
                <div className="col-12">
                    <div className="card">
                        <div className="grid">
                            <div className="col-12">
                                <h4 className="text-center font-bold">{t("judicial-records.title")?.toUpperCase()}</h4>
                            </div>
                            <SearchForm />
                            <div className="col-12"></div>
                            <JudicialRecordsTable />
                        </div>
                    </div>
                </div>
            </div>
        </Provider>
    );
};
